// extracted by mini-css-extract-plugin
export default {"choice":"Answer_choice__On9mr"};